import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#008C23',
        opacity: 1,
        border: 0,
      },
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.5,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#EE3B2B',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const ToggleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const StatusLabel = styled('span')(({ active }) => ({
  fontSize: '14px',
  fontWeight: 500,
  color: active ? '#008C23' : '#EE3B2B',
}));

export default function StatusToggle({ 
  initialStatus = 'ACTIVE', 
  onStatusChange = () => {},
  disabled = false,
  organizationId 
}) {
  const [isActive, setIsActive] = useState(initialStatus === 'ACTIVE');
  const [isUpdating, setIsUpdating] = useState(false);

  // Sync local state when initialStatus prop changes
  useEffect(() => {
    setIsActive(initialStatus === 'ACTIVE');
  }, [initialStatus]);

  const handleToggle = async (event) => {
    const newCheckedValue = event.target.checked;
    const newStatus = newCheckedValue ? 'ACTIVE' : 'INACTIVE';
    
    console.log('Toggle clicked:', { organizationId, currentStatus: initialStatus, newStatus });
    
    setIsUpdating(true);
    try {
      // Call the parent function to handle the API update
      await onStatusChange(organizationId, newStatus);
      setIsActive(newCheckedValue);
    } catch (error) {
      console.error('Failed to update status:', error);
      // Revert the toggle if the update fails
      setIsActive(!newCheckedValue);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <ToggleContainer>
      <StyledSwitch
        checked={isActive}
        onChange={handleToggle}
        disabled={disabled || isUpdating}
        inputProps={{ 'aria-label': 'Status toggle' }}
      />
      {/* <StatusLabel active={isActive}>
        {isUpdating ? 'Updating...' : (isActive ? 'Active' : 'Inactive')}
      </StatusLabel> */}
    </ToggleContainer>
  );
}